<template>
  <v-btn
    icon
    @click="clickBtn()"
  >
    <v-icon
      :class="{toggled: !isVisible}"
    >
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex'
// import * as ArcGIS from '../../helpers/ArcGIS'

export default {
  props: {
    icon: String,
    layerId: String
  },

  data: () => ({
    toggled: true
  }),

  computed: {
    ...mapGetters('map', [
      'layers',
      'etiquetasVisibles'
    ]),

    isVisible() {
      return this.getVisibility()
    }
  },

  mounted() {
    this.getVisibility()
  },

  methods: {
    clickBtn() {
      this.toggled = !this.toggled

      this.$store.dispatch('map/setVisibilityLayer', {
        id: this.layerId,
        visible: this.toggled
      })
    },

    getVisibility() {
      let visible = false

      if (this.layerId === 'layer-etiquetas') {
        const l1 = this.layers.find(x => x.id === 'layer-medios-activos')
        const l2 = this.layers.find(x => x.id === 'layer-medios-inactivos')
        visible = this.etiquetasVisibles && ((l1 && l1.visible) || (l2 && l2.visible))
      } else {
        const l = this.layers.find(x => x.id === this.layerId)
        visible = l ? l.visible : false
      }

      this.toggled = visible
      return visible
    }
  }
}
</script>

<style scoped>
  .toggled {
    color:  rgba(255, 255, 255, 0.521) !important;
  }
</style>
